import { Navigate, useParams } from 'react-router-dom';
import { ReleaseDetail } from '@/features/releases/components/ReleaseDetail';

// Route param is :repoName (matches the URL value — the Gitea repo full_name
// like 'raptor/product-a'). The route comes URL-encoded; react-router decodes
// it for us before we read useParams.
export function ReleaseDetailPage() {
  const { repoName } = useParams<{ repoName: string }>();

  if (!repoName) {
    return <Navigate to="/releases" replace />;
  }

  return <ReleaseDetail repoName={repoName} />;
}
